import React, {useCallback, useMemo} from 'react'
import {Flex} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import Chip from '../../../components/chip'

const ChipRefinement = ({filter, toggleFilter, selectedFilters, value}) => {
    const selected = useMemo(() => selectedFilters?.includes(value.value), [selectedFilters, value])
    const onChange = useCallback(
        () => toggleFilter(value, filter.attributeId, selected, true),
        [value, filter.attributeId, selected, toggleFilter]
    )

    return <Chip name={value.label} orderable selected={selected} onChange={onChange} />
}

ChipRefinement.propTypes = {
    filter: PropTypes.object,
    toggleFilter: PropTypes.func,
    selectedFilters: PropTypes.array,
    value: PropTypes.object
}

const ChipRefinements = ({filter, toggleFilter, selectedFilters}) => {
    return (
        <Flex gap={3} wrap="wrap">
            {filter.values
                ?.filter((refinementValue) => refinementValue.hitCount > 0)
                .map((value) => (
                    <ChipRefinement
                        key={value.value}
                        filter={filter}
                        toggleFilter={toggleFilter}
                        selectedFilters={selectedFilters}
                        value={value}
                    />
                ))}
        </Flex>
    )
}

ChipRefinements.propTypes = {
    filter: PropTypes.object,
    toggleFilter: PropTypes.func,
    selectedFilters: PropTypes.array
}

export default ChipRefinements
